(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .factory('MerchantSearch', MerchantSearch);

  MerchantSearch.$inject = ['$resource', 'API_URI'];

  function MerchantSearch($resource, API_URI) {
    var resourceUrl = API_URI + 'api/_search/merchants/:id';

    return $resource(resourceUrl, {}, {
      'query': {method: 'GET', isArray: true}
    });
  }
})();
